import { tv } from 'tailwind-variants'

export const linkWebStyles = tv({
	base: 'text-palette_6 select-text underline underline-offset-4 text-base font-primary-demi',
})

export const linkNativeStyles = tv({
	base: 'text-palette_6 text-base font-primary-demi',
})
